// Lightweight, client-side-only device fingerprint (FingerprintJS open-source
// community edition -- no external API calls, no cost, MIT licensed) used
// solely to help catch a customer blocked for order-cancellation abuse if
// they try to re-register under a new email or check out as a guest. Sent
// alongside registration and checkout requests; the backend never trusts it
// alone -- it's one signal among phone/address matching, not the sole gate.

const CACHE_KEY = 'acy_device_fp';
let cached = null;
let inflight = null;

export async function getDeviceFingerprint() {
  if (cached) return cached;
  try {
    const stored = localStorage.getItem(CACHE_KEY);
    if (stored) { cached = stored; return cached; }
  } catch { /* localStorage unavailable (private mode, etc.) -- fall through and recompute */ }

  if (!inflight) {
    // The agent is ~125KB and only matters at registration and checkout, and
    // every caller already awaits this function -- so it is fetched on demand
    // rather than riding in the bundle that gates first paint. A failed chunk
    // fetch lands in the same .catch as a failed fingerprint: null, never a
    // blocked signup.
    inflight = import('@fingerprintjs/fingerprintjs')
      .then((m) => m.default.load())
      .then((fp) => fp.get())
      .then((result) => {
        cached = result.visitorId;
        try { localStorage.setItem(CACHE_KEY, cached); } catch { /* ignore */ }
        return cached;
      })
      .catch(() => null) // never block a signup/checkout on this failing
      .finally(() => { inflight = null; });
  }
  return inflight;
}
